import { MARKETPLACE, REGION } from 'root/widgets/constants';
import { PGLoginConfig } from 'root/widgets/pg-login/types';

const commonConfig = {
  AUTH_API_HOST: 'https://auth.integration.guruestate.com',
  USERS_API_HOST: 'https://users-api.kgw.integration.guruestate.com',

  /**
   * following google client id is of dev environment. If you want to test on local
   * (http://localhost:3000), then copy this client id and paste it in respected
   * region config.
   */
  GOOGLE_CLIENT_ID: '367223124563-nqbh60veth48kr448f62mflkasd0kpmp.apps.googleusercontent.com',
  FACEBOOK_CLIENT_ID: '751052508373579',
  APPLE_CLIENT_ID: 'com.propertyguru.www',
};
const config: Record<string, PGLoginConfig> = {
  [`${REGION.SG}-${MARKETPLACE.PG}`]: {
    ...commonConfig,
    GOOGLE_CLIENT_ID: '367223124563-ti1jnu3njfef468olr82iku8j71jfkma.apps.googleusercontent.com',
    FACEBOOK_CLIENT_ID: '1704579266427760',
    GURULAND_HOST: 'https://www.integration.propertyguru.com.sg',
    SYMBIOSIS_API_HOST: 'https://symbiosis.integration.propertyguru.com.sg',
  },
  [`${REGION.SG}-${MARKETPLACE.CG}`]: {
    ...commonConfig,
    GOOGLE_CLIENT_ID: '185477762030-e61pcs1g9c1btomrfpmo0atk23s4efas.apps.googleusercontent.com',
    FACEBOOK_CLIENT_ID: '476495469688355',
    GURULAND_HOST: 'https://www.integration.commercialguru.com.sg',
    SYMBIOSIS_API_HOST: 'https://symbiosis.integration.commercialguru.com.sg',
  },
  [`${REGION.MY}-${MARKETPLACE.PG}`]: {
    ...commonConfig,
    GOOGLE_CLIENT_ID: '115079994079-5p6d4ga4vttjnpq0b7gb31re4mob8k2c.apps.googleusercontent.com',
    FACEBOOK_CLIENT_ID: '1636177523305153',
    GURULAND_HOST: 'https://www.integration.propertyguru.com.my',
    SYMBIOSIS_API_HOST: 'https://symbiosis.integration.propertyguru.com.my',
  },
  [`${REGION.TH}-${MARKETPLACE.PG}`]: {
    ...commonConfig,
    GOOGLE_CLIENT_ID: '711575025382-3vjahlfb1jm79f2bai57q7f7jdboqoeg.apps.googleusercontent.com',
    FACEBOOK_CLIENT_ID: '726099721872634',
    GURULAND_HOST: 'https://www.integration.ddproperty.com',
    SYMBIOSIS_API_HOST: 'https://symbiosis.integration.ddproperty.com',
  },
  [`${REGION.ID}-${MARKETPLACE.PG}`]: {
    ...commonConfig,
    GOOGLE_CLIENT_ID: '362245724631-pks7b7n0kmhulrq2jg2f81m9d1bqrk9d.apps.googleusercontent.com',
    FACEBOOK_CLIENT_ID: '449579755167300',
    GURULAND_HOST: 'https://www.integration.rumah.com',
    SYMBIOSIS_API_HOST: 'https://symbiosis.integration.rumah.com',
  },
};

export default config;
